import { SendMessage as DLSendMessage } from './../DL/Anecdotes.js';
import { ValidateSqlInjection as BLValidateSqlInjection } from './Security.js';

/**
 * Limpia el texto de saltos de línea, tabuladores y espacios dobles.
 * @param {string} text - Texto sucio.
 * @returns {string} - Texto limpio en una sola línea.
 */
const CleanText = (text) => {
    if (!text) return "";
    // Reemplaza cualquier secuencia de espacios en blanco (\n, \t, espacio) por un solo espacio
    // y elimina los espacios al inicio y al final.
    return text.replace(/\s+/g, ' ').trim();
};

/**
 * Procesa el envío de la anécdota aplicando reglas de negocio, sanitización y seguridad.
 * @param {Object} formData - Datos del formulario { content, sender }
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
const SendMessage = async (formData) => {
    try {
        if (!formData) {
            return { success: false, message: '¡Ups! Has olvidado escribir tu anécdota' };
        }

        // 1. Limpieza de Datos (Sanitización)
        const cleanContent = CleanText(formData.content);
        const cleanSender = CleanText(formData.sender);

        // 2. Validación: Contenido vacío
        if (cleanContent === '') {
            return { success: false, message: '¡Ups! Has olvidado escribir tu anécdota' };
        }

        // 3. Validación: Longitud
        if (cleanContent.length > 255) {
            return { success: false, message: 'La anécdota es demasiado larga (máximo 255 caracteres)' };
        }
        if (cleanSender.length > 30) {
            return { success: false, message: 'El nombre es demasiado largo (máximo 30 caracteres)' };
        }

        // 4. Validación: Seguridad (SQL Injection / XSS)
        const isContentUnsafe = await BLValidateSqlInjection(cleanContent);
        const isSenderUnsafe = cleanSender ? await BLValidateSqlInjection(cleanSender) : false;

        if (isContentUnsafe || isSenderUnsafe) {
            return { success: false, message: 'Tu anécdota contiene caracteres no permitidos' };
        }

        // 5. Ejecución: Enviar al Data Layer
        const response = await DLSendMessage({
            content: cleanContent,
            sender: cleanSender !== '' ? cleanSender : 'Anónimo'
        });

        // 6. Retorno de resultado
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, message: response.message };
        }

    } catch (error) {
        return { success: false, message: 'No ha sido posible enviar tu anécdota. Inténtalo nuevamente o inténtalo más tarde' };
    }
};

export { CleanText, SendMessage };
